import React, { memo } from 'react';
import { UserScreenshareSource } from 'features/layout/features/order/types';
import { makeSourceKey } from 'features/streaming/utils';
import { styled } from '@mui/material/styles';
import { Box, Fade } from '@mui/material';
import { TransitionGroup } from 'react-transition-group';
import { ScreenshareTile } from './ScreenshareTile';

const ScreenshareGridContainer = styled(TransitionGroup)<{
  cols: number;
  rows: number;
}>(({ cols, rows }) => ({
  width: '100%',
  height: '100%',
  display: 'grid',
  gridTemplateColumns: `repeat(${cols || 1}, minmax(0, 1fr))`,
  gridTemplateRows: `repeat(${rows || 1}, minmax(0, 1fr))`,
  gap: '8px',
  padding: '8px',
}));

type ScreenshareGridProps = {
  screenshares: UserScreenshareSource[];
  cols: number;
  rows: number;
};

export const ScreenshareGrid = ({ screenshares, cols, rows }: ScreenshareGridProps) => (
  <ScreenshareGridContainer cols={cols} rows={rows} key={`grid-${screenshares.length}`}>
    {screenshares.map((screenshare) => (
      <Fade key={makeSourceKey(screenshare)} in timeout={{ enter: 350, exit: 350 }}>
        <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
          <ScreenshareTile screenshare={screenshare} />
        </Box>
      </Fade>
    ))}
  </ScreenshareGridContainer>
);

export default memo(ScreenshareGrid);
